// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A provisioned sandbox the simulator can connect through.
 */
export class SimulationSandbox implements flatbuffers.IUnpackableObject<SimulationSandboxT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationSandbox {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationSandbox(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationSandbox,
  ): SimulationSandbox {
    return (obj || new SimulationSandbox()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSimulationSandbox(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationSandbox,
  ): SimulationSandbox {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationSandbox()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  slug(): string;
  slug(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  slug(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Vendor addresses the sandbox tunnels.
   */
  vendorAddresses(index: number): string;
  vendorAddresses(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  vendorAddresses(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  vendorAddressesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * True while a tunnel session to the sandbox is up.
   */
  connected(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startSimulationSandbox(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addSlug(builder: flatbuffers.Builder, slugOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, slugOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, organizationIdOffset, 0);
  }

  static addVendorAddresses(
    builder: flatbuffers.Builder,
    vendorAddressesOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, vendorAddressesOffset, 0);
  }

  static createVendorAddressesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startVendorAddressesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addConnected(builder: flatbuffers.Builder, connected: boolean) {
    builder.addFieldInt8(3, +connected, +false);
  }

  static endSimulationSandbox(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // slug
    return offset;
  }

  unpack(): SimulationSandboxT {
    return new SimulationSandboxT(
      this.slug(),
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.bb!.createScalarList<string>(
        this.vendorAddresses.bind(this),
        this.vendorAddressesLength(),
      ),
      this.connected(),
    );
  }

  unpackTo(_o: SimulationSandboxT): void {
    _o.slug = this.slug();
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.vendorAddresses = this.bb!.createScalarList<string>(
      this.vendorAddresses.bind(this),
      this.vendorAddressesLength(),
    );
    _o.connected = this.connected();
  }

  unpackFields(...fields: string[]): SimulationSandboxT {
    const t = new SimulationSandboxT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("slug")) {
      t.slug = this.slug();
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("vendor_addresses")) {
      t.vendorAddresses = this.bb!.createScalarList<string>(
        this.vendorAddresses.bind(this),
        this.vendorAddressesLength(),
      );
    }
    if (fieldSet.has("connected")) {
      t.connected = this.connected();
    }
    return t;
  }
}

export class SimulationSandboxT implements flatbuffers.IGeneratedObject {
  constructor(
    public slug: string | Uint8Array | null = null,
    public organizationId: UuidT | null = null,
    public vendorAddresses: string[] = [],
    public connected: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.slug === null || this.slug === undefined) {
      throw new Error('Required field "slug" is not set');
    }
    const slug = this.slug !== null ? builder.createString(this.slug!) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const vendorAddresses = SimulationSandbox.createVendorAddressesVector(
      builder,
      builder.createObjectOffsetList(this.vendorAddresses),
    );

    SimulationSandbox.startSimulationSandbox(builder);
    SimulationSandbox.addSlug(builder, slug);
    SimulationSandbox.addOrganizationId(builder, organizationId);
    SimulationSandbox.addVendorAddresses(builder, vendorAddresses);
    SimulationSandbox.addConnected(builder, this.connected);

    return SimulationSandbox.endSimulationSandbox(builder);
  }

  clone(): SimulationSandboxT {
    const obj = new SimulationSandboxT();
    obj.slug = this.slug;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.vendorAddresses = [...this.vendorAddresses];
    obj.connected = this.connected;
    return obj;
  }

  equals(other: SimulationSandboxT): boolean {
    if (this.slug !== other.slug) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.vendorAddresses.length !== other.vendorAddresses.length) return false;
    for (let i = 0; i < this.vendorAddresses.length; i++) {
      if (this.vendorAddresses[i] !== other.vendorAddresses[i]) return false;
    }
    if (this.connected !== other.connected) return false;
    return true;
  }
}

export function verifySimulationSandbox(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "slug");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
  } finally {
    verifier.popDepth();
  }
}
